module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BN-feb924c06ccbb68429cb8f02914e0356.png";